// @ts-strict-ignore
import React, { useState } from "react";

import {
  DropdownContentContainer,
  DropDownContainer,
  OptionsDropdownContainer,
  ActiveDropDownContainer,
  CaretIcon,
  Item
} from "./style";
import { Body } from "components/parts/Typography";

const Dropdown = ({
  inputOptions,
  setFirst,
  setOption,
  index = 1,
  color = "white",
  setFirstOptBold = false
}) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  React.useEffect(() => {
    window.addEventListener("click", handleCloseMenuIfOutside);
  });

  const handleCloseMenuIfOutside = (event: MouseEvent) => {
    if (
      !((event.target as HTMLElement).getAttribute("data-name") === "dropdown")
    ) {
      setMenuOpen(false);
    }
  };

  const openMenuHandler = (e) => {
    e.preventDefault();
    setMenuOpen(true);
  };

  const Tab = ({ active = false, onClick = (_) => null }) => (
    <DropDownContainer
      active={active}
      index={index}
      data-name="dropdown"
      onClick={onClick}
      color={color}
    >
      <Body
        size="md"
        as="div"
        m="0"
        semiBold={setFirstOptBold}
        data-name="dropdown"
      >
        {inputOptions[0]}
        <CaretIcon />
      </Body>
    </DropDownContainer>
  );

  const OptionsDropdown = ({ children }) => (
    <OptionsDropdownContainer>
      {!!menuOpen && (
        <DropdownContentContainer index={index} color={color}>
          <DropdownContent />
        </DropdownContentContainer>
      )}
      {children}
    </OptionsDropdownContainer>
  );

  const DropdownContent = () => (
    <ActiveDropDownContainer color={color}>
      {inputOptions.map((tab, index) => {
        const onClickHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();
          setFirst(inputOptions, index, setOption);
          setMenuOpen(false);
        };
        return (
          <Item
            onClick={onClickHandler}
            key={index}
            data-name={index === 0 && "dropdown"}
          >
            <Body
              size="md"
              as="span"
              m="0"
              semiBold={index === 0 && setFirstOptBold}
            >
              {tab}
            </Body>
            {index === 0 && <CaretIcon active />}
          </Item>
        );
      })}
    </ActiveDropDownContainer>
  );

  return (
    <OptionsDropdown>
      <Tab active onClick={openMenuHandler} />
    </OptionsDropdown>
  );
};

export default Dropdown;
